<template>
  <b-nav :style="{ backgroundColor: color }">
    <b-nav-item to="/">
      <img src="@/assets/images/svgs/Logo.svg" alt="Logo">
    </b-nav-item>
    <b-nav-text style="flex-grow:1"></b-nav-text>
    <b-nav-item to="/">Search</b-nav-item>
    <b-nav-item href="/#trends">Trendy Now</b-nav-item>
    <b-nav-item href="/#favorites">Favorites</b-nav-item>
    <b-nav-text style="flex-grow:1"></b-nav-text>
    <b-nav-item v-if="!$store.state.loggedIn" to="/login">Login</b-nav-item>
    <b-nav-item v-if="$store.state.loggedIn" @click="logout">Logout</b-nav-item>
  </b-nav>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {};
  },
  computed: {
    color() {
      // const r = this.$route.path;
      // if (r.match(/\/article\/[\w]{24}/gm)) return 'var(--blue)';
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>

.nav {
  height: 6em;
  background-color: var(--background-color);
  padding: 0 2em;
  font-family: 'Poppins-Regular';
  font-size: 26px;
  color: var(--text-color);
}

.navbar-text, .nav-item, .nav-link {
  display: flex;
  align-items: center;
  color: var(--text-color);
}

.router-link-exact-active {
  color: var(--interaction-color);
}

</style>
